/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_TitleInputs */

const en_pc_cmp_title = /** @type {(inputs: Pc_Cmp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft vs Adobe Acrobat`)
};

const zh_pc_cmp_title = /** @type {(inputs: Pc_Cmp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 对比 Adobe Acrobat`)
};

/**
* | output |
* | --- |
* | "PdfCraft vs Adobe Acrobat" |
*
* @param {Pc_Cmp_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_title = /** @type {((inputs?: Pc_Cmp_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_title(inputs)
	return zh_pc_cmp_title(inputs)
});
export { pc_cmp_title as "pc.cmp.title" }